/**
 * Every cache key in one file.
 *
 * Same reasoning as the partner console's: two screens sharing a key see each other's
 * data, and a write that invalidates the wrong key leaves a stale number on screen. The
 * hierarchy exists so a prefix invalidates everything beneath it — placing an order calls
 * `invalidateQueries({ queryKey: keys.orders.all })` and both the list and the detail
 * refetch, without the caller having to know which of them was mounted.
 */
export const keys = {
  account: ['account'],

  partners: {
    all: ['partners'],
    list: (filters) => ['partners', 'list', filters],
    detail: (slug) => ['partners', 'detail', slug],
  },

  orders: {
    all: ['orders'],
    list: (filters) => ['orders', 'list', filters],
    detail: (orderId) => ['orders', 'detail', orderId],
  },
}
